import type { GlobalPrimitiveFieldId, ResolvedMonospaceCollection } from '#layers/data-model/public';
import { SortDirection } from '#layers/base/public';
import { getCollectionPrimaryKeyFields, sortFieldsBySortKey } from '#layers/data-model/public';

/**
 * Sort by the first primary key field, falling back to the first field in display order the
 * collection sorts by, ascending where accepted; unsorted when it sorts by none.
 */
export function initialSortState(collection: ResolvedMonospaceCollection, directions: (fieldId: GlobalPrimitiveFieldId) => SortDirection[]) {
	const candidates = [...getCollectionPrimaryKeyFields(collection), ...sortFieldsBySortKey(collection.primitiveFields)];

	for (const field of candidates) {
		const allowed = directions(field.id);
		const direction = allowed.includes(SortDirection.Ascending) ? SortDirection.Ascending : allowed[0];
		if (direction) return [{ fieldId: field.id, direction }];
	}

	return [];
}
